// extracted by mini-css-extract-plugin
export default {"root":"DateFilter_root__EbEpP","applyButton":"DateFilter_applyButton__LKjAD","customDateOpenContainerMargin":"DateFilter_customDateOpenContainerMargin__VSS70"};